import { createMetricsFactory } from 'metrics-js';
export const Metrics = createMetricsFactory('hs_resources', {
  library: 'hs-resources'
});